import { startLoading, endLoading } from '../../../app-dux/app-dux';
import recognitionService from '../../../services/recognition';
import rosterService from '../../../services/roster';
import { getSelectedPeople } from './selectors';
import * as types from './types';
import { getUser } from '../../../app-auth';

export const setPeople = people => ( { type: types.SET_SEARCHED_PEOPLE, people } );
export const setMyTeam = myTeam => ( { type: types.SET_MY_TEAM, myTeam } );
export const addSelectedPerson = ( person ) => ( { type: types.ADD_SELECTED_PERSON, person } );

export const searchParticipant = ( searchText ) => dispatch => {
    dispatch( startLoading() );
    return recognitionService.searchParticipants( searchText ).then(
        results => {
            dispatch( setPeople( results.persons.filter( ( item ) => item.status === 'active' ) ) );
            dispatch( endLoading() );
        }
    ).catch( ( error ) => {
        dispatch( endLoading() );
        console.error( error );
    } );
};

export const getPersonDetail = ( personId ) => dispatch => {
    return recognitionService.getPersonDetail( personId ).then(
        results => {
            return results.nodes[ 0 ].id;
        }
    );
};

export const getPeopleFromNode = ( nodeId ) => async dispatch => {
    const authState = await getUser();
    return rosterService.getTeamMembers( nodeId ).then(
       results => {
           dispatch( setMyTeam( results.filter( ( item ) => item.id !== authState.claims.person_id ) ) );
       } 
    );
};

export const selectedRecipientAdd = ( person ) => ( dispatch, getState ) => {
    const selectedPeople = getSelectedPeople( getState() );
    let found = false;
    if ( selectedPeople )
    {
        for ( let i = 0; i < selectedPeople.length; i++ ) {
            if ( selectedPeople[ i ].id === person.id ) {
                found = true;
                break;
            }
        }
    }
    if ( !found ) 
    {
        person = { ...person, awardValue: 0 };
        
        dispatch( addSelectedPerson( person ) );
    }
    
};

export const removeSelectedPerson = ( person ) => ( dispatch ) => {
    dispatch( { type: types.REMOVE_SELECTED_PERSON, person } );
};
export const clearSearchedRecipients = () => dispatch => {
    dispatch( { type: types.CLEAR_SEARCHED_PEOPLE } );
};
